import { Upload } from "antd";
import { UploadChangeParam, UploadFile } from "antd/lib/upload/interface";
import { Plus } from "lucide-react";
import React, { FC } from "react";
import { Icon } from "src/components/icons/Icon";
import { useFileManagement } from "src/hooks/useFileManagement";

interface IProps {
	value?: string;
	onChange?: (url?: string) => void;
}

const CourseThumbnail: FC<IProps> = React.forwardRef<HTMLDivElement, IProps>(
	({ value, onChange }, ref) => {
		const { getFileUrl } = useFileManagement();

		const handleChange = (info: UploadChangeParam<UploadFile<any>>) => {
			if (onChange) {
				onChange(info.file.response);
			}
		};

		const thumbnail = value ? getFileUrl(value) : "";

		return (
			<div ref={ref} data-testid="courseThumbnail">
				<Upload
					name="File"
					listType="picture-card"
					accept="image/*"
					showUploadList={false}
					headers={{
						"X-CSRF": "1",
					}}
					action={`/${process.env.REACT_APP_API_URI}/clientapi/FileManagement`}
					onChange={handleChange}
				>
					{value ? (
						<img src={thumbnail} alt="thumbnail image" className="org-logo" />
					) : (
						<div>
							<Icon icon={Plus} />
							<p>Upload</p>
						</div>
					)}
				</Upload>
			</div>
		);
	}
);

export default CourseThumbnail;
